export default {"src":"__ASTRO_ASSET_IMAGE__pRq6XWj5__","width":18,"height":18,"format":"png"}